import { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [fingerprint, setFingerprint] = useState(null);
  const [tempFingerprint, setTempFingerprint] = useState(null);

  return (
    <AuthContext.Provider value={{ fingerprint, setFingerprint, tempFingerprint, setTempFingerprint }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within an AuthProvider');
  return context;
};
